import React, { useEffect, useState } from 'react';
import './superagentes.css';


/* =========================================================
   PERSONAJES
========================================================= */

const personajes = [
  {
    id: 1,
    nombre: 'Súper Honesta',
    imagen: '/assets/imgs/dibujos/honesta.jpeg',
  },
  {
    id: 2,
    nombre: 'Súper Responsable',
    imagen: '/assets/imgs/dibujos/responsable.jpeg',
  },
  {
    id: 3,
    nombre: 'Eco',
    imagen: '/assets/imgs/dibujos/eco.jpeg',
  },
  {
    id: 4,
    nombre: 'Lupo',
    imagen: '/assets/imgs/dibujos/lupo.jpeg',
  },
  {
    id: 5,
    nombre: 'Diego',
    imagen: '/assets/imgs/dibujos/diego.jpeg',
  },
  {
    id: 6,
    nombre: 'Rosita',
    imagen: '/assets/imgs/dibujos/rosita.jpeg',
  },
  {
    id: 7,
    nombre: 'Pepe',
    imagen: '/assets/imgs/dibujos/pepe.jpeg',
  },
  {
    id: 8,
    nombre: 'Susy',
    imagen: '/assets/imgs/dibujos/susy.jpeg',
  },
];


/* =========================================================
   DIBUJOS PARA COLOREAR
========================================================= */

const dibujos = [
  {
    id: 1,
    imagen: '/videos/fotos-agentes/personajes/honesta.jpeg',
    nombre: 'Súper Honesta',
  },
  {
    id: 2,
    imagen: '/videos/fotos-agentes/personajes/responsabilidad.jpeg',
    nombre: 'Súper Responsable',
  },
  {
    id: 3,
    imagen: '/videos/fotos-agentes/personajes/ambiente.jpeg',
    nombre: 'Eco',
  },
  {
    id: 4,
    imagen: '/videos/fotos-agentes/personajes/igualdad.jpeg',
    nombre: 'Lupo',
  },
];


/* =========================================================
   JUEGOS
========================================================= */

const juegos = [
  {
    id: 1,
    imagen: '/videos/fotos-agentes/juegos/cruci.png',
    nombre: 'Crucigrama de Valores',
  },
  {
    id: 2,
    imagen: '/videos/fotos-agentes/juegos/letras.png',
    nombre: 'Sopa de Letras',
  },
  {
    id: 3,
    imagen: '/videos/fotos-agentes/juegos/gato.jpeg',
    nombre: 'Juego del Gato',
  },
  {
    id: 4,
    imagen: '/videos/fotos-agentes/juegos/valores.png',
    nombre: 'Desafío de Valores',
  },
  {
    id: 5,
    imagen: '/videos/fotos-agentes/juegos/rompecabezas.jpeg',
    nombre: 'Rompecabezas',
  },
];


/* =========================================================
   VIDEOS
========================================================= */

const videos = [
  {
    id: 1,
    src: '/videos/fotos-agentes/Susy_Diego_47.mp4',
    titulo: 'Conoce a los Súper Agentes',
  },
  {
    id: 2,
    src: '/videos/fotos-agentes/Eco_48.mp4',
    titulo: 'Nuestra misión',
  },
  {
    id: 3,
    src: '/videos/fotos-agentes/Lupo_48.mp4',
    titulo: 'Actividades',
  },
  {
    id: 4,
    src: '/videos/fotos-agentes/SH_SR_47.mp4',
    titulo: 'Súper Honesta y Súper Responsable',
  },
];


/* =========================================================
   FOTOS / MISIONES
========================================================= */

const fotos = [
  '/videos/fotos-agentes/04.jpg',
  '/videos/fotos-agentes/05.jpg',
  '/videos/fotos-agentes/06.jpeg',
  '/videos/fotos-agentes/12.jpg',
  '/videos/fotos-agentes/14.jpg',
  '/videos/fotos-agentes/16.JPG',
  '/videos/fotos-agentes/13.jpg',
  '/videos/fotos-agentes/15.jpg',
  '/videos/fotos-agentes/17.JPG',
  '/videos/fotos-agentes/18.jpg',
];


/* =========================================================
   COMPONENTE
========================================================= */

const SuperAgentes = () => {

  const [videoActivo, setVideoActivo] = useState(0);
  const [fotoActiva, setFotoActiva] = useState(0);


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);


  const siguienteFoto = () => {
    setFotoActiva(
      (actual) =>
        (actual + 1) % fotos.length
    );
  };


  const fotoAnterior = () => {
    setFotoActiva(
      (actual) =>
        (actual - 1 + fotos.length) %
        fotos.length
    );
  };


  return (

    <main className="super-agentes-page">


      {/* =================================================
          HERO
      ================================================= */}

      <section className="super-hero">

        <div className="super-hero-decor decor-left"></div>
        <div className="super-hero-decor decor-right"></div>

        <div className="super-hero-content">


          <div className="super-logo-area">

            <div className="super-logo-comic">

              <span className="super-word">
                SÚPER
              </span>

              <span className="agentes-word">
                AGENTES
              </span>

            </div>

            <span className="super-slogan">
              Pequeños héroes, grandes acciones
            </span>

          </div>


          <div className="super-welcome">

            <h1>
              ¡Bienvenido,
              <br />
              Súper Agente!
            </h1>

            <p>
              Aquí aprenderás jugando,
              te divertirás y descubrirás
              cómo puedes hacer del mundo
              un lugar mejor.
            </p>

            <strong>
              ¡Únete a la misión!
            </strong>

          </div>


          <div className="super-hero-photo">

            <img
              src="/videos/fotos-agentes/04.jpg"
              alt="Súper Agentes"
            />

          </div>

        </div>

      </section>


      {/* =================================================
          MENÚ DE COLORES
      ================================================= */}

      <section className="super-menu">

        <a
          href="#programa"
          className="super-menu-card menu-vino"
        >
          <i className="fa-solid fa-book-open"></i>

          <span>
            Conoce el
            <br />
            Programa
          </span>
        </a>


        <a
          href="#juegos"
          className="super-menu-card menu-naranja"
        >
          <i className="fa-solid fa-gamepad"></i>

          <span>
            Juegos y
            <br />
            Actividades
          </span>
        </a>


        <a
          href="#misiones"
          className="super-menu-card menu-verde"
        >
          <i className="fa-solid fa-shield-halved"></i>

          <span>
            Misiones
          </span>
        </a>


        <a
          href="#videos"
          className="super-menu-card menu-morado"
        >
          <i className="fa-solid fa-circle-play"></i>

          <span>
            Videos
          </span>
        </a>


        <a
          href="#fotos"
          className="super-menu-card menu-azul"
        >
          <i className="fa-solid fa-camera"></i>

          <span>
            Fotos
          </span>
        </a>


        <a
          href="#dibujos"
          className="super-menu-card menu-rosa"
        >
          <i className="fa-solid fa-pencil"></i>

          <span>
            Dibujos para
            <br />
            colorear
          </span>
        </a>

      </section>


      {/* =================================================
          CONOCE LOS PERSONAJES
      ================================================= */}

      <section
        id="programa"
        className="super-section"
      >

        <div className="super-section-title">

          <i className="fa-solid fa-star"></i>

          <h2>
            Conoce a los Súper Agentes
          </h2>

        </div>


        <div className="super-personajes">

          {personajes.map((personaje) => (

            <article
              key={personaje.id}
              className="super-personaje-card"
            >

              <img
                src={personaje.imagen}
                alt={personaje.nombre}
              />

            </article>

          ))}

        </div>

      </section>


      {/* =================================================
          CONTENIDO PRINCIPAL
      ================================================= */}

      <section className="super-content-grid">


        {/* =============================================
            DIBUJOS
        ============================================= */}

        <div
          id="dibujos"
          className="super-panel"
        >

          <div className="super-panel-title">

            <i className="fa-solid fa-palette"></i>

            <h3>
              Dibuja con los Súper Agentes
            </h3>

          </div>


          <div className="super-dibujos-grid">

            {dibujos.map((dibujo) => (

              <article
                key={dibujo.id}
                className="super-dibujo-card"
              >

                <img
                  src={dibujo.imagen}
                  alt={dibujo.nombre}
                />


                <a
                  href={dibujo.imagen}
                  download
                >

                  <i className="fa-solid fa-download"></i>

                  Descargar

                </a>

              </article>

            ))}

          </div>

        </div>


        {/* =============================================
            MISIONES
        ============================================= */}

        <div
          id="misiones"
          className="super-panel super-mission-panel"
        >

          <div className="super-panel-title">

            <i className="fa-solid fa-star"></i>

            <h3>
              Misiones
            </h3>

          </div>


          <div className="super-mission-carousel">

            <img
              src={fotos[fotoActiva]}
              alt="Misión Súper Agentes"
            />


            <button
              type="button"
              className="super-gallery-arrow left"
              onClick={fotoAnterior}
            >
              <i className="fa-solid fa-chevron-left"></i>
            </button>


            <button
              type="button"
              className="super-gallery-arrow right"
              onClick={siguienteFoto}
            >
              <i className="fa-solid fa-chevron-right"></i>
            </button>

          </div>


          <div className="super-photo-dots">

            {fotos.map((_, index) => (

              <button
                key={index}
                type="button"
                onClick={() =>
                  setFotoActiva(index)
                }
                className={
                  fotoActiva === index
                    ? 'active'
                    : ''
                }
              />

            ))}

          </div>

        </div>


        {/* =============================================
            VIDEOS
        ============================================= */}

        <div
          id="videos"
          className="super-panel"
        >

          <div className="super-panel-title">

            <i className="fa-solid fa-circle-play"></i>

            <h3>
              Videos
            </h3>

          </div>


          <video
            key={videos[videoActivo].src}
            controls
            playsInline
            className="super-video"
          >

            <source
              src={videos[videoActivo].src}
              type="video/mp4"
            />

          </video>


          <h4 className="super-video-title">
            {videos[videoActivo].titulo}
          </h4>


          <div className="super-video-buttons">

            {videos.map((video, index) => (

              <button
                key={video.id}
                type="button"
                className={
                  videoActivo === index
                    ? 'active'
                    : ''
                }
                onClick={() =>
                  setVideoActivo(index)
                }
              >

                {index + 1}

              </button>

            ))}

          </div>

        </div>


        {/* =============================================
            JUEGOS
        ============================================= */}

        <div
          id="juegos"
          className="super-panel super-games-panel"
        >

          <div className="super-panel-title">

            <i className="fa-solid fa-gamepad"></i>

            <h3>
              Juegos
            </h3>

          </div>


          <div className="super-games-grid">

            {juegos.map((juego) => (

              <article
                key={juego.id}
                className="super-game-card"
              >

                <img
                  src={juego.imagen}
                  alt={juego.nombre}
                />


                <span>
                  {juego.nombre}
                </span>


                <a
                  href={juego.imagen}
                  download
                >
                  Descargar
                </a>

              </article>

            ))}

          </div>

        </div>

      </section>


      {/* =================================================
          MENSAJE FINAL
      ================================================= */}

      <section className="super-final-message">

        <div className="super-final-icon">

          <i className="fa-solid fa-people-group"></i>

        </div>


        <div>

          <h2>
            Construyendo un Futuro
            <strong> Mejor</strong>
          </h2>

          <p>
            Promovemos los derechos de niñas,
            niños y adolescentes en todo el
            estado.
          </p>

          <strong>
            ¡Juntos construimos un futuro mejor!
          </strong>

        </div>

      </section>

    </main>

  );

};


export default SuperAgentes;